import api from './base.service'

export default {
  async imprimirDocumentoSap(tipo, docEntry) {
    try {
      const response = await api.get(
        `/documentos/sap/${tipo}/${docEntry}/pdf`,
        {
          responseType: 'blob'
        }
      )

      const url = URL.createObjectURL(response.data)
      const win = window.open(url, '_blank')
      if (!win) {
        URL.revokeObjectURL(url)
        throw new Error(
          'El browser bloqueó la apertura del PDF. Habilita los popups para este sitio.'
        )
      }
      win.onload = () => {
        win.print()
        URL.revokeObjectURL(url)
      }
    } catch (error) {
      const responseData = error?.response?.data
      let detalle = ''

      const extraerDetalleDesdeTexto = (texto) => {
        const textoLimpio = typeof texto === 'string' ? texto.trim() : ''
        if (!textoLimpio) return ''

        try {
          const json = JSON.parse(textoLimpio)
          return json?.error || json?.Error || textoLimpio
        } catch (_) {
          return textoLimpio
        }
      }

      if (responseData instanceof Blob) {
        const texto = await responseData.text()
        detalle = extraerDetalleDesdeTexto(texto)
      } else if (typeof responseData === 'string') {
        detalle = extraerDetalleDesdeTexto(responseData)
      } else {
        detalle = responseData?.error || responseData?.Error || ''
      }

      if (detalle) {
        error.mensajeDetallado = detalle
        if (error?.response?.data && typeof error.response.data === 'object') {
          error.response.data.error = error.response.data.error || detalle
        }
      }

      throw error
    }
  }
}
